import { defineAsyncComponent } from 'vue';
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const LatestNewsAndVideos = defineAsyncComponent(() => import('@/js/global/widgets/LatestNewsAndVideos.vue'));

app.use(VueSplide);

app.component('LatestNewsAndVideos', LatestNewsAndVideos);

mountApp();
